import { render, staticRenderFns } from "./SuiteFilter.vue?vue&type=template&id=4d84f0bc&"
import script from "./SuiteFilter.vue?vue&type=script&lang=js&"
export * from "./SuiteFilter.vue?vue&type=script&lang=js&"
import style0 from "./SuiteFilter.vue?vue&type=style&index=0&id=4d84f0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports